module.exports = __webpack_public_path__ + "static/media/dummy1.b75ef65b.jpg";